<template>
  <div class="card" v-if="Object.keys(image).length">
    <div class="card-image">
      <figure class="image is-4by3">
        <img v-if="img" :src="getImage(image.file)" id="post-image-preview" />
      </figure>
    </div>
    <div class="card-content">
      <template v-for="(entry, i) in Object.entries(image)">
        <div
          class="columns"
          :key="'row-' + i"
          v-if="!['created', 'edited'].includes(entry[0])"
        >
          <div class="column" v-if="entry[0] !== 'tags'">
            <p>
              <strong>
                {{ entry[0] }}
              </strong>
            </p>
            <p class="mt-1">
              <input
                type="text"
                class="input"
                v-model="image[entry[0]]"
                :disabled="
                  entry[0] === 'file' ||
                    entry[0] === 'id' ||
                    entry[0] === 'gallery_id'
                "
              />
            </p>
          </div>
          <div class="column" v-else>
            <p>
              <strong>
                {{ entry[0] }}
              </strong>
            </p>
            <div class="input-mock">
              <vue-tags-input
                v-model="tag"
                :tags="tags"
                @tags-changed="newTags => (tags = newTags)"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "GalleryImage",
  props: {
    img: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: () => 9999999
    }
  },
  components: {
    VueTagsInput: VueTagsInput
  },
  data() {
    return {
      upload: false,
      tag: "",
      tags: []
    };
  },
  methods: {
    toggle(value) {
      this.upload = value;
    },
    getImage(img) {
      return process.env.VUE_APP_SERVER + "uploads/" + img;
    },
    emitData(value) {
      // emit gallery data to parent
      this.$emit("updateGalleryImage", { value: value, index: this.index });
    }
  },
  computed: {
    image: {
      get() {
        return this.img;
      },
      set(value) {
        this.emitData(value);
        this.imgData = value;
      }
    }
  },
  filters: {
    capitalize(value) {
      if (value && value !== "agm")
        return value[0].toUpperCase() + value.substring(1);
      else if (value && value === "agm") return value.toUpperCase();
      else return value;
    },
    cleanTitle(value) {
      if (value) return value.replace(/_/g, " ");
      else return value;
    }
  }
};
</script>

<style lang="scss">
figure.image {
  max-height: 300px !important;
  overflow-y: hidden;
  img {
    width: 100% !important;
    height: auto !important;
  }
}
</style>
